import React from 'react';
import { useFela } from 'react-fela';

const rules = ({ theme }) => ({
  bottom: '60px',
  color: theme.color.light,
  height: '100px',
  position: 'absolute',
  right: '75px',
  width: '67px',
  zIndex: '2',
});

const Curve = () => {
  const { css } = useFela();

  return (
    <svg className={css(rules)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67 100">
      <path fill="none" stroke="currentColor" strokeWidth="3" d="M0,0 C25,15 50,30 67,100" />
    </svg>
  );
};

export default React.memo(Curve);
